/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import { connect } from 'react-redux';

import './Home.scss';

/**

first page to render when user logs in

@param

**/

export class Home extends Component {
    
    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);     
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    render () {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center content">
                <img src={`${process.env.PUBLIC_URL}/static/images/Admin_landing.png`} alt="homepage" className="homepage" />
                <h5 className="my-4"><b>Welcome to CTBIDS Admin</b></h5>
            </div>
        );
    }
}

export default connect(state => state)(Home);
